<script setup>

import StaticWidget from "@/components/common/other/StaticWidget";
import Button from "@/components/common/input/Button";
import StaticTooltip from "@/components/common/other/StaticTooltip"
import SlideInDrawer from "@/components/common/navigation/SlideInDrawer";
import ShipmentDocumentDownload from "@/components/shipments/ShipmentDocumentDownload";
import LoadingSpinner from "@/components/common/other/LoadingSpinner";
import {ViewShipment} from "@/classes/viewmodels/ViewShipment";
import API from "@/classes/global/API";
import {ElMessage} from 'element-plus'

import {useGetDocumentsList} from "@/composables/common/useGetDocumentsList";
import {useCreateSubstringText} from "@/composables/common/useCreateSubstringText";
import {useStore} from 'vuex';
import {useRoute} from "vue-router";
import {useRouter} from 'vue-router';


import {ref, inject, onMounted} from 'vue';
import CollectionDelivery from "@/components/shipments/CollectionDelivery.vue";
import DetailedInformation from "@/components/shipments/DetailedInformation.vue";
import Containers from "@/components/shipments/Containers.vue";
import Tabs from "@/components/common/navigation/tabs/Tabs.vue";
import Customs from "@/components/shipments/Customs.vue";
import WarehouseShipmentDetail from "@/components/warehouse/WarehouseShipmentDetail.vue";
import TabsContent from "@/components/common/navigation/tabs/TabsContent.vue";
import {computed} from "@vue/reactivity";
import DocumentUpload from "@/components/common/other/DocumentUpload.vue";
import Notification from "@/classes/component-classes/Notification";
import Modal from "@/components/common/other/Modal.vue";
import WarehouseItemDetails from "@/components/warehouse/WarehouseItemDetails.vue";

const shipments = inject("shipments");
const store = useStore();
const route = useRoute();
const router = useRouter();


const showWarehouseTab = computed(() => {

  if(shipments.value.viewShipment.warehouseHeaders.length > 0) return true

  return false;
})

const selectedDocsTab = ref("Current Docs");

const showContainers = computed(() => {

  if(shipments.value.viewShipment.mode.toLowerCase() === shipments.value.modes.sea.toLowerCase()) {
    return true;

  } else {
    shipments.value.selectedViewShipmentTab = 'Milestones';
    return false
  }

});

onMounted(async () => {

  await router.isReady();

  getSelectedShipment();

  shipments.value.files = [];

})

async function sendUpdatedDocuments() {

  let bookingType = shipments.value.viewShipment.mode;
  if(!bookingType) bookingType = "FREIGHT";

  let result = await API.updateJobDocuments(bookingType, shipments.value.files,
      shipments.value.viewShipment.id, shipments.value.viewShipment.jobNumber);

  if(!result) return store.state.banners.error = new Notification(true, 'There Was A Problem Sending To The Message Queue');

  store.state.banners.success = new Notification(true, 'Notification Sent Successfully');
}

function saveToClipboard(text, heading) {

  try {

    navigator.clipboard.writeText(text);


  } catch (e) {

    console.log(`An error occurred trying to copy to clipboard ${e}`)
  }

  ElMessage({
    message: 'Copied To Clipboard',
    type: "success"
  })

}

async function getSelectedShipment() {

  const shipment = await API.getShipmentData(route);

  if (shipment) {

    store.state.hideLoadingSpinner = true;

    shipments.value.viewShipment = shipment;

  } else {

    shipments.value.viewShipment = new ViewShipment();
  }

}

function checkModeForBol() {

  if (shipments.value.mode === shipments.value.modes.road) return true;
  if (shipments.value.mode === shipments.value.modes.sea) return true;

  return false;

}

function editShipment(routeParams) {

  let bookingType = routeParams.mode;

  // Have to convert the Other & Courier sent from the selected tab, to the respective names for the services.

  if (routeParams.mode === 'Other') bookingType = 'freightBooking';
  if (routeParams.mode === 'Courier') bookingType = 'courierBooking';

  if (bookingType === 'freightBooking' || bookingType === 'courierBooking') {

    router.push({name: 'booking', params: {owner: store.state.owner, section: bookingType, id: route.params.id}})

  } else {

    router.push({name: 'prejob', params: {owner: store.state.owner, section: routeParams.mode, id: route.params.id}})
  }

}

function openTracking(url) {

  window.open(url);
}

</script>

<template id="Vue-3-view-component-view-shipments" class="view-view-shipments">
  <LoadingSpinner :hide="store.state.hideLoadingSpinner"></LoadingSpinner>
  <SlideInDrawer
      :height="380"
      title="View / Add Documents"
      v-model:open-drawer="shipments.shipmentDocsDrawer">
    <Tabs v-model:selectedTab="selectedDocsTab">
      <TabsContent
          name="Current Docs"
          :selectedTab="selectedDocsTab">
        <ShipmentDocumentDownload
            v-model="shipments">
        </ShipmentDocumentDownload>
      </TabsContent>
      <TabsContent
          name="Add Docs"
          :selectedTab="selectedDocsTab">
        <img src="@/assets/icons/akar/akar-icons--triangle-alert.png"> COMING SOON!
        <div style=" font-size: 12px; color: #4d4d4d; margin-top: 20px;">The ability to add documents to
        a booking or job after it's created.</div>
<!--        <DocumentUpload v-model="shipments" :key="shipments.viewShipment.files"></DocumentUpload>-->
<!--        <Button-->
<!--            style="position: absolute; right: 50px; bottom: 70px"-->
<!--            @click="sendUpdatedDocuments()"-->
<!--            text="Send Notification">-->
<!--        </Button>-->
      </TabsContent>
    </Tabs>

  </SlideInDrawer>
  <StaticWidget
      background="#fafafa"
      height="735"
      title="Shipment Details">
    <template #extra-content>
    </template>
    <template #right-side>
      <Button
          v-if="shipments.viewShipment.isEditable"
          @click="editShipment(route.params)"
          text="Edit"
          type="info">
      </Button>
      <Button
          @click="useGetDocumentsList(route.params.id, route, store, shipments)"
          type="warning"
          text="Documents">
      </Button>
      <Button
          :disabled="true"
          type="secondary"
          icon="<i class='fa-duotone fa-tag'></i>"
          title="Later Feature"
          text="Label">
      </Button>
      <Button
          v-if="checkModeForBol()"
          text="BOL">
      </Button>
    </template>
    <div class="view-view-shipments_container">
      <div class="view-view-shipments_wrapper">
        <div class="view-view-shipments_header-detail">
          <div>
            <StaticTooltip>
              <template #content>Copy To Clipboard</template>
              <span class="view-view-shipments_toolbar-clipboard-icons"
                    @click="saveToClipboard(shipments.viewShipment.jobNumber, 'jobNumber')">
              <img src="@/assets/icons/copy_to_clipboard.png">
            </span>
            </StaticTooltip>
            <span class="view-view-shipments_toolbar-headings">Job Number:</span>
            <span class="view-view-shipments_toolbar-data">{{ shipments.viewShipment.jobNumber }}</span>
          </div>
          <StaticTooltip>
            <template #content>Copy To Clipboard</template>
            <span @click="saveToClipboard(shipments.viewShipment.customerRef, 'custRef')">
                  <img src="@/assets/icons/copy_to_clipboard.png">
            </span>
            <span class="view-view-shipments_toolbar-headings">Customer Ref:</span>
            <span class="view-view-shipments_toolbar-data">{{ shipments.viewShipment.customerRef }}</span>
          </StaticTooltip>
          <div>
            <span class="view-view-shipments_toolbar-headings">Mode:</span>
            <span class="view-view-shipments_toolbar-data">{{ shipments.viewShipment.mode || 'Other' }}</span>
          </div>
        </div>
        <div class="view-view-shipments_heading">Journey Details</div>
        <div class="view-view-shipments_shipper-details">
          <div class="view-view-shipments_shipper-details-card">
            <div class="view-view-shipments_card-header">Shipper & Contact</div>
            <div class="view-view-shipments_origin-dest-area">
              <div style="display: block" :title="shipments.viewShipment.shipperOrigin">
                <div class="view-view-shipments_origin-title">Origin</div>
                <span style="padding-left: 5px; font-size: 12px">{{ useCreateSubstringText(shipments.viewShipment.shipperOrigin, 30) }}</span>
              </div>
              <div class="view-view-shipments_origin-icon"><img src="@/assets/icons/origin.png"></div>
            </div>
            <div class="view-view-shipments_address-contact-area">
              <div class="view-view-shipments_address">
                <div style="font-weight: bold; margin-bottom: 5px;">
                  {{ useCreateSubstringText(shipments.viewShipment.shipperName, 50) }}
                </div>
                <div :title="address" v-for="address in shipments.viewShipment.shipperAddress">{{ address }}</div>
              </div>
              <div class="view-view-shipments_contact">
                <div style="font-weight: bold;">
                  {{ useCreateSubstringText(shipments.viewShipment.shipperContact.name, 50) }}
                </div>
                <div style="font-size: 9px; margin-bottom: 5px;">
                  {{ useCreateSubstringText(shipments.viewShipment.shipperContact.position, 50) }}
                </div>
                <div class="global-center-items"
                     v-if="shipments.viewShipment.shipperContact.name"
                     style="margin-bottom: 4px;"
                     :title="shipments.viewShipment.shipperContact.email">
                  <img style="margin-right: 5px; height:15px" src="@/assets/icons/email_small.png">
                  {{ useCreateSubstringText(shipments.viewShipment.shipperContact.email, 35) || 'Email Not Provided' }}
                </div>
                <div class="global-center-items" v-if="shipments.viewShipment.shipperContact.name">
                  <img style="margin-right: 5px; height:12px" src="@/assets/icons/phone_small.png">
                  {{ useCreateSubstringText(shipments.viewShipment.shipperContact.telephone, 35) || 'Number Not Provided'}}
                </div>
              </div>
            </div>
          </div>
          <div class="view-view-shipments_shipper-details-card">
            <div class="view-view-shipments_card-header">Consignee & Contact</div>
            <div class="view-view-shipments_origin-dest-area">
              <div style="display: block" :title="shipments.viewShipment.consigneeDestination">
                <div class="view-view-shipments_destination-title">Destination</div>
                <span style="padding-left: 5px; font-size: 12px">
                  {{ useCreateSubstringText(shipments.viewShipment.consigneeDestination, 30) }}</span>
              </div>
              <div class="view-view-shipments_origin-icon"><img src="@/assets/icons/destination.png"></div>
            </div>
            <div class="view-view-shipments_address-contact-area">
              <div class="view-view-shipments_address">
                <div style="font-weight: bold; margin-bottom: 5px;">
                  {{ useCreateSubstringText(shipments.viewShipment.consigneeName, 50) }}
                </div>
                <div :title="address" v-for="address in shipments.viewShipment.consigneeAddress">{{ address }}</div>
              </div>
              <div class="view-view-shipments_contact">
                <div style="font-weight: bold;">
                  {{ useCreateSubstringText(shipments.viewShipment.consigneeContact.name, 50) }}
                </div>
                <div style="font-size: 9px; margin-bottom: 5px;">
                  {{ useCreateSubstringText(shipments.viewShipment.consigneeContact.position, 50) }}
                </div>
                <div class="global-center-items" style="margin-bottom: 4px;"
                     v-if="shipments.viewShipment.consigneeContact.name"
                     :title="shipments.viewShipment.consigneeContact.email">
                  <img style="margin-right: 5px; height:15px" src="@/assets/icons/email_small.png">
                  {{ useCreateSubstringText(shipments.viewShipment.consigneeContact.email, 35) || 'Email Not Provided' }}
                </div>
                <div class="global-center-items" v-if="shipments.viewShipment.consigneeContact.name">
                  <img style="margin-right: 8px; height:12px" src="@/assets/icons/phone_small.png">
                  {{ useCreateSubstringText(shipments.viewShipment.consigneeContact.telephone, 35) || 'Number Not Provided' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="view-view-shipments_heading">Consignment </div>
        <div class="view-view-shipments_consignment-section">
          <div class="view-view-shipments_goods-information-container">
            <div class="view-view-shipments_card-header">Goods Information</div>
            <div class="view-view-shipments_goods-information-wrapper">
              <div>
                <div class="view-view-shipments_goods-grid">
                  <div>
                    <div class="label">Pieces</div>
                    {{shipments.viewShipment.consignmentDetails.nop}}
                  </div>
                  <div>
                    <div class="label">Weight</div>
                    {{shipments.viewShipment.consignmentDetails.actualWeight}}
                  </div>
                  <div>
                    <div class="label">Cube</div>
                    {{shipments.viewShipment.consignmentDetails.cube}}
                  </div>
                  <div>
                    <div class="label">Chargeable Weight</div>
                    {{shipments.viewShipment.consignmentDetails.weight}}
                  </div>
               </div>
                <div class="view-view-shipments_inco-term">
                  <div>
                    <div class="label">Incoterm</div>
                    <div style="font-size: 12px; padding-top: 5px;">
                      {{shipments.viewShipment.detailedInformation.incoTerms.split('-')[0]}}
                    </div>
                  </div>
                  <div class="view-view-shipments_inco-term-desc">
                    {{shipments.viewShipment.detailedInformation.incoTerms.split('-')[1] || 'Incoterm Detail'}}
                  </div>
                </div>
              </div>
              <div style="width: 100%;">
                <div class="label">Description</div>
                <div class="view-view-shipments_goods-description">
                  {{shipments.viewShipment.consignmentDetails.description || 'No Description'}}
                </div>
              </div>
            </div>
          </div>
          <div v-if="shipments.viewShipment.mode" class="view-view-shipments_mode-detail-area">
            <div v-if="shipments.viewShipment.mode.toLowerCase() === shipments.modes.air.toLowerCase()"
                 class="view-view-shipments_mode-detail-layout view-view-shipments_mode-detail-layout-air">
              <img style="margin: 0 0 0 20px" src="@/assets/icons/mode_air.png">
              <div>
                <div class="label">Flight Number</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.air.flightNumber || 'N/A' }}</div>
              </div>
              <div>
                <div class="label">Flight 2 No.</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.air.secondFlightNumber || 'N/A' }}
                </div>
              </div>
              <div>
                <div class="label">AWB Number</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.air.awbNumber || 'N/A'}}</div>
              </div>
              <div>
                <div class="label">HAWB</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.air.hawb || 'N/A'}}</div>
              </div>
              <div>
                <div class="label">Flight Date</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.air.flightDate || 'N/A'}}</div>
              </div>
              <Button
                  style="margin-top: 3px"
                  v-if="store.state.userSettings.showAirTrackingLink"
                  :disabled="!shipments.viewShipment.detailedInformation.air.trackingUrl"
                  @click="openTracking(shipments.viewShipment.detailedInformation.air.trackingUrl)"
                  text="AWB Tracking"
                  type="secondary">
              </Button>
            </div>
            <div v-if="shipments.viewShipment.mode.toLowerCase() === shipments.modes.courier.toLowerCase()"
                 class="view-view-shipments_mode-detail-layout view-view-shipments_mode-detail-layout-courier">
              <img style="margin: 0 0 0 20px" src="@/assets/icons/mode_courier.png">
              <div>
                <div class="label">Consignment Number</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.courier.consignmentNumber || 'N/A' }}</div>
              </div>
              <div>
                <div class="label">POD</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.courier.podName || 'N/A' }}</div>
              </div>
              <div>
                <div class="label">POD Date</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.courier.podDate || 'N/A' }}</div>
              </div>
              <div>
                <div class="label">POD Time</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.courier.podTime || 'N/A' }}</div>
              </div>
              <div>
                <div class="label">Additional Ref</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.courier.additionalRef || 'N/A'}}</div>
              </div>
              <div>
                <div class="label">Value</div>
                <div style="padding-top: 4px;"> {{ shipments.viewShipment.detailedInformation.courier.value || 'N/A' }}</div>
              </div>
            </div>
            <div v-if="shipments.viewShipment.mode.toLowerCase() === shipments.modes.sea.toLowerCase()"
                class="view-view-shipments_mode-detail-layout view-view-shipments_mode-detail-layout-sea">
              <img style="margin: 0 0 0 20px" src="@/assets/icons/mode_sea.png">
              <div>
                <div class="label">B/L Number</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.sea.blNumber || 'N/A' }}</div>
              </div>
              <div>
                <div class="label">HBL</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.sea.hbl || 'N/A' }}</div>
              </div>
              <div>
                <div class="label">Vessel</div>
                <div style="padding-top: 6px; font-size: 11px;">
                  {{ shipments.viewShipment.detailedInformation.sea.vessel || 'N/A' }}</div>
              </div>
              <div>
                <div class="label">Voyage Number</div>
                <div style="padding-top: 4px;">{{ shipments.viewShipment.detailedInformation.sea.voyageNumber || 'N/A' }}</div>
              </div>
              <div>
                <Button
                    style="margin-top: 3px"
                    v-if="store.state.userSettings.showSeaTrackingLink"
                    :disabled="!shipments.viewShipment.detailedInformation.sea.trackingUrl"
                    @click="openTracking(shipments.viewShipment.detailedInformation.sea.trackingUrl)"
                    text="TRACK"
                    type="secondary">
                </Button>
              </div>
            </div>
          </div>
          <div style=" margin-top: 20px">
            <Tabs v-model:selectedTab="shipments.selectedViewShipmentTab" :key="shipments.viewShipment.mode ||
             showWarehouseTab">
              <TabsContent
                  name="Milestones"
                  :selectedTab="shipments.selectedViewShipmentTab">
                <DetailedInformation></DetailedInformation>
              </TabsContent>
              <TabsContent
                  v-if="showWarehouseTab"
                  name="Warehouse"
                  :selectedTab="shipments.selectedViewShipmentTab">
                <WarehouseShipmentDetail></WarehouseShipmentDetail>
              </TabsContent>
              <TabsContent
                  v-if="showContainers"
                  name="Containers"
                  :selectedTab="shipments.selectedViewShipmentTab">
                <Containers></Containers>
              </TabsContent>
              <TabsContent
                  name="Customs"
                  :selectedTab="shipments.selectedViewShipmentTab">
                <Customs></Customs>
              </TabsContent>
              <TabsContent
                  v-if="store.state.userSettings.showPickupDelivery"
                  name="Pickup / Delivery"
                  :selectedTab="shipments.selectedViewShipmentTab">
                <CollectionDelivery></CollectionDelivery>
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  </StaticWidget>
  <Modal
      v-model="shipments.warehousePicksModal"
      title="Warehouse Item Details"
      width="1680px"
      height="480px">
    <template #icon>
      <i class="fa-solid fa-warehouse-full" style="color: #F68E1E; font-size: 20px"></i>
    </template>
    <template #body>
      <WarehouseItemDetails></WarehouseItemDetails>
    </template>
  </Modal>
</template>

<style lang="scss" scoped>

.view-view-shipments {

  &_header-detail {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding-bottom: 5px;
    border-bottom: 1px solid var(--border-color);
    align-items: center;
  }

  &_container {
    display: flex;
    justify-content: center;
    font-size: 14px;
  }

  &_wrapper {
    margin: auto;
    width: 1200px;
  }

  &_toolbar-headings {
    font-weight: bold;
    margin-left: 5px;
  }

  &_toolbar-clipboard-icons {
    cursor: pointer;
  }

  &_toolbar-data {
    margin-left: 5px;
  }

  &_copied-success {
    color: #3f9968;
    width: 13px;
  }

  &_heading {
    font-size: 15px;
    color: #3a3a3a;
    padding: 10px 0 10px 0;
  }

  &_shipper-details {
    display: flex;
    justify-content: space-between;
  }

  &_shipper-details &_shipper-details-card {
    position: relative;
    height: 135px;
    width: 540px;
    background: #fdfdfd;
    border-radius: 6px;
    box-shadow: 1px 1px 8px 0px #d2d2d2;
    padding: 10px 0 10px 10px;
  }

  &_card-header {
    color: var(--aqua-blue-definition);
    font-weight: bold;
    font-size: 13px;
    padding-bottom: 10px;
  }

  &_address-contact-area {
    display: flex;
    font-size: 12px;
  }

  &_address {
    width: 300px;
    height: 100px;
    display: block;
  }

  &_origin-dest-area {
    position: absolute;
    display: flex;
    gap: 150px;
    height: 55px;
    width: 260px;
    top: -30px;
    right: 10px;
    background: #f6f6f6;
    box-shadow: 1px 1px 8px 1px #d2d2d2;
    border-radius: 6px;
  }

  &_origin-title, &_destination-title {
    width: 0px;
    padding: 5px;
    font-size: 16px;
    font-weight: bold;
    color: #d98325
  }

  &_destination-title {
    color: #689ba4
  }

  &_origin-icon {
    position: absolute;
    right: 10px;
    top: 10px;
  }

  &_goods-information-container {
    height: 130px;
    border-radius: 6px;
    box-shadow: 1px 1px 8px 1px #e8e8e8;
    background: #fdfdfd;
    padding: 10px 10px 0 10px;
  }

  &_goods-information-wrapper {
    display: flex;
    gap: 100px;
  }

  &_goods-grid {
    display: grid;
    grid-template-columns: 150px 150px 150px 103px;
    margin-bottom: 4px;
    color: #545454;
  }

  &_inco-term {
    padding-top: 10px;
    display: grid;
    grid-template-columns: 240px 200px;
    border-top: 1px solid #ececec;
  }

  &_inco-term-desc {
    border: 1px solid var(--border-color);
    height: 36px;
    width: 300px;
    border-radius: 6px;
    overflow-y: scroll;
    font-size: 11px;
    color: #3f3f3f;
    padding: 5px;
    word-break: break-word;

  }

  &_goods-description {
    height: 70px;
    border: 1px solid var(--border-color);
    border-radius: 6px;
    word-break: break-word;
    overflow-y: scroll;
    font-size: 12px;
    padding: 5px;
  }

  &_mode-detail-layout, &_mode-detail-layout-air, &_mode-detail-layout-courier, &_mode-detail-layout-sea {
    display: grid;
    padding-top: 10px;
    margin-top: 20px;
    height: 40px;
    color: #545454;
    border-radius: 6px;
    box-shadow: 1px 1px 8px 1px #e8e8e8;
    background: #fdfdfd;
  }

  &_mode-detail-layout-air {
    grid-template-columns: 100px 180px 180px 180px 140px 270px 100px;
  }

  &_mode-detail-layout-courier {
    grid-template-columns: 100px 220px 180px 180px 180px 200px 120px;
  }

  &_mode-detail-layout-sea {
    grid-template-columns: 100px 220px 180px 280px 280px 80px
  }

  &_mode-detail-area {
    margin-top: 10px;
    height: 80px;
    overflow-y: auto;
  }

}
</style>
